import { combineEpics } from 'redux-observable';
import computeListEpic from './ComputeListEpic';
import deleteCompute from './ComputeDeleteEpic';
export const rootEpic = combineEpics(computeListEpic, deleteCompute);
export default rootEpic;

//# sourceMappingURL=epics.js.map
